import React from "react";
import {
  imgsectioneight,
  imgsectionfive,
  imgsectionfour,
  imgsectionone,
  imgsectionsix,
  imgsectionthree,
  imgsectiontwo,
} from "../../assets/images";

const MainPage = () => {
  return (
    <div>
      <div className="section-page-flex section-page page-section-one">
        <div className="col-md-7 pt-5 mt-5 section-page-one-inner">
          <h1 className="heading-pages">Hubconnect </h1>
          <h1 className="heading-pages">Communications Private </h1>
          <h1 className="heading-pages">Limited </h1>
          <h3 className="sub-div-headings">
            Revolutionizing Customer Interactions with AI and ML
          </h3>
        </div>
        <div className="col-md-5">
          <img src={imgsectionone} alt="Section One" className="img-fluid" />
        </div>
      </div>
      <div className="section-page-flex section-page page-section-two ">
        <div className="col-md-5">
          <img src={imgsectiontwo} alt="Section Two" className="img-fluid" />
        </div>
        <div className="col-md-7">
          <h1 className="pt-5 mt-5 ms-2 heading-pages">Who We Are</h1>
          <div className="row">
            <div className="inner-text-section-card-type-1 sub-text-pages col-md-6 p-4">
              Hubconnect is a leading provider of AI and ML-powered solutions
              for customer engagement. We help businesses enhance efficiency,
              elevate customer satisfaction, and drive productivity.
            </div>
            <div className="inner-text-section-card-type-1 sub-text-pages col-md-5 p-4">
              We offer a comprehensive range of solutions, including intelligent
              chatbots, automated outbound calls, smart call answering, and
              email and website integration. We also provide outsourced contact
              center services.
            </div>
          </div>
        </div>
      </div>
      <div className="section-page page-section-three">
        <div className="row">
          <img src={imgsectionthree} alt="Section Two" className="img-fluid" />
        </div>
        <div>
          <h1 className="pt-5 mt-3 ms-2 heading-pages">
            Our AI and ML-Powered Solutions
          </h1>
        </div>
        <div className="p-3 row">
          <div className="col section-inner-card m-2">
            <h2 className="sub-text-pages"> WhatsApp Solutions</h2>
            <h3 className="inner-text-content-two">
              Engage customers 24/7 with AI-driven chatbots, live agent
              integration, and personalized engagement.
            </h3>
          </div>
          <div className="col section-inner-card m-2">
            <h2 className="sub-text-pages"> Call Center Automation</h2>
            <h3 className="inner-text-content-two">
              Optimize inbound and outbound calls with automated systems, voice
              analytics, and call back facilities.
            </h3>
          </div>
          <div className="col section-inner-card m-2">
            <h2 className="sub-text-pages"> Email and Website Integration</h2>
            <h3 className="inner-text-content-two">
              Streamline email responses and provide instant website support
              with AI-powered tools.
            </h3>
          </div>
        </div>
      </div>
      <div className="section-page page-section-four">
        <h1 className="pt-5 ms-5 heading-pages">Why Choose Hubconnect?</h1>
        <div className="row">
          <div className="col-md-5">
            <img
              src={imgsectionfour}
              alt="Section Five"
              className="img-fluid"
            />
          </div>
          <div className="col-md-7">
            <div className="p-3 row">
              <div className="col section-inner-card-bottom-border">
                <h2 className="sub-text-pages">Transformative Technology</h2>
                <h3 className="inner-text-content-two">
                  AI and ML power our solutions, enabling businesses to predict
                  customer needs, automate tasks, and analyze interactions
                </h3>
              </div>
            </div>
            <div className="p-3 row">
              <div className="col section-inner-card-bottom-border">
                <h2 className="sub-text-pages">Seamless Integration</h2>
                <h3 className="inner-text-content-two">
                  Our solutions integrate seamlessly into your existing systems,
                  ensuring smooth operations across all channels.
                </h3>
              </div>
            </div>
            <div className="p-3 row">
              <div className="col section-inner-card-bottom-border">
                <h2 className="sub-text-pages">Scalable and Customizable</h2>
                <h3 className="inner-text-content-two">
                  We provide tailored solutions that can adapt to your unique
                  needs and scale as your business grows.
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section-page section-page-flex page-section-five ">
        <div className="col-md-5">
          <img src={imgsectionfive} alt="Section Five" className="img-fluid" />
        </div>
        <div className="col-md-7">
          <div>
            <h1 className="pt-5 mt-5 ms-2 heading-pages">
              Our Outsourced Contact Center Services
            </h1>
          </div>
          <div className="p-3 row">
            <div className="col section-inner-card m-2">
              <h2 className="sub-text-pages">24/7 Multichannel Support</h2>
              <h3 className="inner-text-content-two">
                Deliver exceptional customer experiences across phone, email,
                chat, and social media.
              </h3>
            </div>
            <div className="col section-inner-card m-2">
              <h2 className="sub-text-pages">Trained Workforce</h2>
              <h3 className="inner-text-content-two">
                Empower agents with AI-assisted tools for efficiency and
                accuracy.
              </h3>
            </div>
          </div>
          <div className="p-3 row">
            <div className="col section-inner-card m-2">
              <h2 className="sub-text-pages">Custom Service Models</h2>
              <h3 className="inner-text-content-two">
                Tailor services to meet the specific demands of your industry.
              </h3>
            </div>
            <div className="col section-inner-card m-2">
              <h2 className="sub-text-pages">Performance Optimization</h2>
              <h3 className="inner-text-content-two">
                Track and improve key metrics like first call resolution (FCR)
                and customer satisfaction (CSAT).-powered tools.{" "}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div className="section-page page-section-six">
        <div className="row">
          <img src={imgsectionsix} alt="Section Two" className="img-fluid" />
        </div>
        <div className="p-2">
          <div>
            <h1 className="pt-5 mt-3 ms-2 heading-pages">
              Industries We Serve
            </h1>
          </div>
          <div className="p-3 row">
            <div className="col section-inner-card m-2">
              <h2 className="sub-text-pages"> Banking & Finance</h2>
              <h3 className="inner-text-content-two">
                AI-driven compliance and customer support for financial
                institutions.
              </h3>
            </div>
            <div className="col section-inner-card m-2">
              <h2 className="sub-text-pages"> Retail & E-commerce</h2>
              <h3 className="inner-text-content-two">
                Personalized engagement and enhanced support for online and
                brick-and-mortar retailers.
              </h3>
            </div>
            <div className="col section-inner-card m-2">
              <h2 className="sub-text-pages"> Healthcare</h2>
              <h3 className="inner-text-content-two">
                Streamlined appointment scheduling and improved patient
                communication.
              </h3>
            </div>
            <div className="col section-inner-card m-2">
              <h2 className="sub-text-pages">Telecommunications</h2>
              <h3 className="inner-text-content-two">
                AI-powered customer service for increased efficiency and
                enhanced support.
              </h3>
            </div>
          </div>
        </div>
      </div>{" "}
      <div className="section-page page-section-seven">
        <h1 className="pt-5 mt-5 ms-4 heading-pages">
          Join the Future of Customer Interaction
        </h1>
        <div className="m-5">
          <div className="row mt-3">
            <div className="col-md-2 dark-green-section"></div>
            <div className="col-md-10 section-inner-card-bottom-border">
              <h2 className="sub-text-pages ">Embrace Innovation</h2>
              <h3 className="inner-text-content-two">
                Embrace the power of AI and ML to redefine customer engagement
                and drive your business forward.
              </h3>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-4 light-green-section"></div>
            <div className="col-md-8 section-inner-card-bottom-border">
              <h2 className="sub-text-pages ">Contact Us Today</h2>
              <div className="col-md-10 ">
                <h3 className="inner-text-content-two">
                  Reach out to our team to explore how our solutions can benefit
                  your business.
                </h3>
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-6 less-green-section"></div>
            <div className="col-md-6 section-inner-card-bottom-border">
              <div className="col-md-10">
                <h2 className="sub-text-pages">Let's Partner</h2>
                <h3 className="inner-text-content-two">
                  Together, we can achieve unparalleled customer satisfaction
                  and business growth.
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className=" section-page section-page-flex page-section-eight ">
        <div className="col-md-5">
          <img
            src={imgsectioneight}
            alt="Section Eight"
            className="img-fluid"
          />
        </div>
        <div className="col-md-7 p-4 ms-2 pt-5 mt-5">
          <h1 className="heading-pages">
            The Future of Customer Engagement is Here{" "}
          </h1>
          <h3 className="inner-text-content-three">
            Hubconnect Communications Private Limited is your trusted partner in
            revolutionizing customer interactions. Let's create a future where
            technology empowers businesses to build lasting relationships with
            their customers.{" "}
          </h3>
        </div>
      </div>
    </div>
  );
};

export default MainPage;
